import React from "react";
import { Form, Select, Label } from "semantic-ui-react";

const SelectedInput = ({
  input,
  handleOnChange,
  width,
  options,
  placeholder,
  meta: { touched, invalid, error },
  disabled,
}) => {
  return (
    <Form.Field error={touched && !!error} width={width}>
      <Select
        value={input.value}
        onChange={(e, data) => {
          input.onChange(data.value);
          if (handleOnChange) handleOnChange(data.value);
        }}
        onBlur={(e, data) => {
          input.onBlur(data);
        }}
        placeholder={placeholder}
        options={options}
        disabled={disabled}
      />
      {touched && error && (
        <Label pointing basic color="red">
          {error}
        </Label>
      )}
    </Form.Field>
  );
};

export default SelectedInput;
